module.exports = __webpack_public_path__ + "img/linux.c204f91a.png";